export const printEthAccount = (account: string): string => {
  if (account.length) {
    const shortenedAccount: string =
      account.substring(0, 6) + '...' + account.substring(account.length - 4);
    return shortenedAccount;
  }
  return '';
};
export const printEthBalance = (balance: string): string => {
  if (balance) {
    const shortenedBalance: string = balance.substring(0, 6) + ' ETH';
    return shortenedBalance;
  }
  return '';
};
